"use client";
import { jsxs as t, jsx as i } from "react/jsx-runtime";
import s from "clsx";
import { memo as f } from "react";
import { Box as u } from "../../blocks/base/Base.js";
import { s as a } from "../../Input.module-DvgZOYt7.js";
const y = f(
  ({
    type: m = "text",
    name: r,
    placeholder: l,
    icon: e,
    center: n,
    value: p,
    className: h,
    loading: c,
    disabled: _,
    error: d,
    size: N = "normal",
    onClick: v,
    onReset: o,
    ...x
  }) => /* @__PURE__ */ t(u, { gap: 12, children: [
    r && /* @__PURE__ */ i("span", { className: s(a.name, { [a._center]: n }), children: r }),
    /* @__PURE__ */ t("label", { className: a.label, children: [
      /* @__PURE__ */ i(
        "input",
        {
          className: s(a.input, a[N], {
            [a._loading]: c,
            [a._error]: d,
            [a._disabled]: _
          }),
          type: m,
          placeholder: l,
          value: p,
          onClick: v,
          ...x
        }
      ),
      e && /* @__PURE__ */ i(
        "div",
        {
          className: s("material-icons", a.icon, a.icon__main),
          "data-icon": c ? "progress_activity" : e
        }
      ),
      /* @__PURE__ */ i(
        "div",
        {
          className: s("material-icons", a.icon, a.icon__ok),
          "data-icon": c ? "progress_activity" : "check_circle"
        }
      ),
      o && /* @__PURE__ */ i(
        "div",
        {
          className: s(
            "material-icons",
            a.icon,
            a.icon__reset
          ),
          "data-icon": c ? "progress_activity" : "close",
          onClick: o
        }
      )
    ] })
  ] })
);
y.displayName = "Input";
export {
  y as Input
};
